import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchBySequence'
})
export class SearchBySequencePipe implements PipeTransform {

  transform(items: any[], searchText: string): any {
    if (!items) return [];

    if (!searchText) return items;

    
    return items.filter(it => {
      return it.sysSampleId === parseInt(searchText);
          
  });
  

  }

}
